import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Flex,
  Button,
} from "@chakra-ui/react";
import { LOMA_GREEN, LOMA_DARK_TEAL, LOMA_GREEN_HOVER } from "../constants/colors";

interface LaunchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLaunch: () => void;
}

const LaunchModal: React.FC<LaunchModalProps> = ({
  isOpen,
  onClose,
  onLaunch,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={false}
      motionPreset="slideInBottom"
      blockScrollOnMount={false}
    >
      <ModalOverlay bg="transparent" backdropFilter="none" />
      <ModalContent
        position="fixed"
        left={{ base: "0", md: "5" }}
        bottom="5"
        right="0"
        m="0"
        borderRadius="lg"
        boxShadow="lg"
        p={{ base: 3, md: 4 }}
        maxH={{ base: "80vh", md: "auto" }}
        overflowY="auto"
      >
        <ModalHeader
          position="relative"
          fontSize={{ base: "md", md: "lg" }}
          py={{ base: 2, md: 3 }}
          color="gray.800"
        >
          Ready to Launch?
        </ModalHeader>
        <ModalCloseButton onClick={onClose} color="gray.800" />
        <ModalBody pb={{ base: 3, md: 4 }}>
          <Flex width="full" direction="column" gap={4}>
            <Button
              size={{ base: "md", md: "lg" }}
              onClick={onLaunch}
              width="full"
              height={{ base: "48px", md: "56px" }}
              bgGradient={`linear(135deg, #7BC9CC 0%, #357E81 100%)`}
              color="white"
              borderRadius={{ base: "12px", md: "16px" }}
              fontSize={{ base: "md", md: "lg" }}
              fontWeight="600"
              py={{ base: 4, md: 6 }}
              _hover={{
                bgGradient: `linear(135deg,rgb(114, 188, 191) 0%,rgb(43, 105, 107) 100%)`,
                transform: "translateY(-2px)",
                boxShadow: `0 12px 24px -4px rgb(114, 188, 191)40`
              }}
            >
              Make it mine! 🎉
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LaunchModal;
